// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"83":"90b3fe61","5170":"858ac215","5928":"935870de"}[chunkId] + ".css";
};